import { Fragment } from 'react';

import { Button } from '@/components/UI/Button';
import { cn } from '@/utils/ui';

import { SearchIcon } from '../SearchIcon/SearchIcon';
import { type NavigationLink } from './Header';

interface HeaderCTAButtonsProps {
  isSearchActive?: boolean;
  ctas: NavigationLink[];
}

export function HeaderCTAButtons(props: HeaderCTAButtonsProps): React.ReactNode {
  const { isSearchActive = false, ctas } = props;

  return (
    <div
      data-testid="HeaderCTAButtons"
      className={cn('order-3 ml-auto flex items-center md:relative', {
        'justify-between': ctas.length,
        'justify-end': !ctas.length,
      })}
    >
      <SearchIcon isSearchActive={isSearchActive} className="hidden md:flex" />
      {ctas.map((cta, index) => {
        const dataAnalyticsStr =
          cta.title && typeof cta.title === 'string'
            ? cta.title.toLowerCase().replace(/ /g, '')
            : 'main-landing-header-cta';

        return (
          <Fragment key={`cta-element-${String(index)}`}>
            {index > 0 && (
              <span className="relative top-px hidden h-4 w-[2px] bg-[#808080] md:inline" aria-hidden="true" />
            )}
            <Button
              className={cn('whitespace-nowrap', cta.className, {
                'pr-0': index === ctas.length - 1,
              })}
              onClick={cta.onClick}
              variant={cta.variant}
              size="sm"
              dataAnalytics={`main-landing-${dataAnalyticsStr}-button`}
            >
              {cta.title}
            </Button>
          </Fragment>
        );
      })}
    </div>
  );
}
